export default __webpack_public_path__ + "static/media/img-clio.4d7d072f.png";